import React, { createContext, useContext, useState, ReactNode } from 'react';

interface CommandSearchContextType {
  isSearchOpen: boolean;
  openSearch: () => void;
  closeSearch: () => void;
}

const CommandSearchContext = createContext<CommandSearchContextType | undefined>(undefined);

export const CommandSearchProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const openSearch = () => setIsSearchOpen(true);
  const closeSearch = () => setIsSearchOpen(false);

  return (
    <CommandSearchContext.Provider value={{ isSearchOpen, openSearch, closeSearch }}>
      {children}
    </CommandSearchContext.Provider>
  );
};

export const useCommandSearchContext = () => {
  const context = useContext(CommandSearchContext);
  if (context === undefined) {
    throw new Error('useCommandSearchContext must be used within a CommandSearchProvider');
  }
  return context;
};